// extracted by mini-css-extract-plugin
export default {"section":"Ix-z","sectionTitle":"Jx-z","fieldWrapper":"Kx-z","formField":"Lx-z","disabled":"Mx-z","formLabel":"Nx-z"};